module.exports = __webpack_public_path__ + "img/Logo.0602674b.svg";